import {useTranslation} from 'react-i18next';
import {
  Control,
  UseFormWatch,
  UseFormSetValue,
  useFieldArray,
} from 'react-hook-form';
import {SVG} from '../../../../../../../constants/assetLists';
import {FormDataType} from '../../../types';
import AppTextInput from '../../../../../../../components/common/AppTextInput';

type Props = {
  index: number;
  control: Control<FormDataType>;
  watch: UseFormWatch<FormDataType>;
  setValue: UseFormSetValue<FormDataType>;
  errors: any;
};

function DropdownOptions({index, control, errors, watch, setValue}: Props) {
  const {t} = useTranslation();

  const {fields, append, remove} = useFieldArray({
    control,
    name: `questions.${index}.options` as any,
  });

  const handleAddOption = () => {
    const questionId = watch(`questions.${index}.id`);
    append({
      id: `${questionId}-opt-${Date.now()}`,
      title: '',
    });
  };

  return (
    <div className="flex flex-col gap-2">
      {fields.map((field, optIndex) => {
        const optionTitle = watch(
          `questions.${index}.options.${optIndex}.title` as any,
        ) as string;
        const optionError = errors?.options?.[optIndex]?.title?.message || '';

        return (
          <div key={field.id} className="flex items-center gap-4">
            <div className="w-[20px] text-center text-[16px] text-textColor flex-shrink-0">
              {optIndex + 1}.
            </div>

            <AppTextInput
              placeholder={`${t('forms.dialog.option')} ${optIndex + 1}`}
              className="flex-1 border-none"
              value={optionTitle || ''}
              error={optionError}
              onChange={e => {
                setValue(
                  `questions.${index}.options.${optIndex}.title` as any,
                  e.target.value,
                  {shouldDirty: true},
                );
              }}
            />

            {fields.length > 2 && (
              <button
                type="button"
                onClick={() => remove(optIndex)}
                className="p-1">
                <img
                  src={SVG.closeDarkIcon}
                  alt="remove"
                  className="w-[16px] h-[16px] object-contain"
                />
              </button>
            )}
          </div>
        );
      })}

      <div className="flex items-center gap-2 mt-4">
        <span className={'text-[16px] text-[#1D1B20]'}>
            {t('forms.dialog.add')}
        </span>

        <button
          type="button"
          onClick={handleAddOption}
          className="text-[16px] text-linkBlue underline font-bold">
          {t('forms.dialog.option')}
        </button>
      </div>
    </div>
  );
}

export default DropdownOptions;
